import { Component } from '@angular/core';

import { NativeSearchService } from './native-search.service';

@Component({
    selector: 'ohp-search-preload',
    template: ''
})
export class SearchPreloadComponent {
    constructor(
        nativeSearchService: NativeSearchService
    ) {
        nativeSearchService.configureSearchBox();
    }
}
